<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  totalCount?: number
  partialCount?: number
  partialName?: string
}>(), {
  totalCount: 0,
  partialCount: 0,
  partialName: ''
})

const percentage = computed(() => !props.totalCount ? 0 : Math.round(props.partialCount / props.totalCount * 100))
</script>

<template>
  <div class="bx-progress">
    <span class="bx-progress__name">{{ partialName }}</span>
    <div class="bx-progress__bar">
      <div class="bx-progress__bar-inner"
           :style="`width: ${percentage}%`" />
    </div>
    <span class="bx-progress__percentage">
      {{ percentage }} %
    </span>
  </div>
</template>
